<template>
  <div id="app">
    <app-header app-title="Streets-Pay" app-subtitle="Payment Center">
      <mobile-nav slot="mobile-nav">
        <ul>
          <li>
            <a
              href="https://www.phila.gov/departments/department-of-streets/"
              target="_blank"
              >Department of Streets</a
            >
          </li>
          <li>
            <a href="https://www.phila.gov/terms-of-use/" target="_blank"
              >Terms of Use</a
            >
          </li>
          <li>
            <a href="mailto:Streets.IThelp@phila.gov">Provide Feedback</a>
          </li>
          <li>
            <a href="https://www.phila.gov/privacypolicy/" target="_blank"
              >Privacy Policy</a
            >
          </li>
        </ul>
      </mobile-nav>
    </app-header>
    <main class="container is-4">
      <div class="columns is-multiline is-12">
        <div class="column is-3"></div>
        <div class="column is-12"><router-view /></div>
      </div>
    </main>

    <app-footer :links="footerLinks"> </app-footer>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      footerLinks: [
        {
          text: "Department of Streets", //the route name is used, and not the path
          href: "https://www.phila.gov/departments/department-of-streets/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Provide Feedback", //the route name is used, and not the path
          href: "mailto:Streets.IThelp@phila.gov", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Terms of Use", //the route name is used, and not the path
          href: "https://www.phila.gov/terms-of-use/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
        {
          text: "Privacy Policy", //the route name is used, and not the path
          href: "https://www.phila.gov/privacypolicy/", //the route name is used, and not the path
          type: "native", //any other html anchor attributes
          attrs: { target: "_blank" },
        },
      ],
    };
  },
  /**
   * Lifecycle hook called before the component is mounted.
   * Clears the local storage and logs the current date and time.
   */
  beforeMount() {
    console.log("Clearing local storage", new Date());
  },

  methods: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
</style>
